import deliverUserEvent from './deliver-user-event';
import { Layer } from '../../../models/layer-settings';
import activeLayerCountsByType from './layer-count-helper';

/**
 * Send a Map Layers Applied event to Mixpanel via our Rails backend.
 * @param mapEngine: web_map_engine flag, string|null
 * @param basemap: active basemap id, string
 * @param activeOverlays: activeOverlays on layerSettings, Layer[]
 * @returns Promise<any>; Success message or error message from Rails controller
 */
export default async function mapLayersAppliedEvent(
  mapEngine: string|null,
  basemap: string,
  activeOverlays: Layer[],
) {
  const payload = eventPayload(mapEngine, basemap, activeOverlays);

  return deliverUserEvent(payload);
}

export const eventPayload = (
  mapEngine: string|null,
  basemap: string,
  activeOverlays: Layer[],
) => {
  const payload = new FormData();
  payload.append('event_type', 'map');
  payload.append('event_action', 'layers_applied');
  payload.append('event_data', JSON.stringify({
    web_map_engine: mapEngine ?? 'Google',
    basemap,
    active_layers_count: activeOverlays.length,
    ...activeLayerCountsByType(activeOverlays),
  }));

  return payload;
};
